import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './meeting-archives.types';
import * as constants from './meeting-archives.constants';

export const meetingArchivesReducer = generateResourceReducer<types.IMeetingArchive>({
  STORE: constants.STORE_MEETING_ARCHIVE,
  CLEAR: constants.CLEAR_MEETING_ARCHIVE,
});
